import * as React from "react";

const Custom_Box_Grey = ({color = "#484848" , style}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    style={style}
  >
    <path
      fill={color}
      fillOpacity="0.2"
      d="M26.8 9.255c0 .72-.387 1.373-1 1.706l-2.32 1.254-1.974 1.053-4.093 2.213c-.44.24-.92.36-1.414.36s-.973-.12-1.413-.36l-8.387-4.52c-.613-.333-1-.986-1-1.706s.387-1.374 1-1.707l2.627-1.413L10.919 5l3.667-1.973c.88-.48 1.947-.48 2.827 0l8.386 4.52c.614.333 1 .987 1 1.707M13.202 17.055l-7.8-3.906a1.9 1.9 0 0 0-1.866.08c-.574.346-.907.96-.907 1.626v7.374a3.33 3.33 0 0 0 1.853 3l7.8 3.893c.267.133.56.2.854.2a1.8 1.8 0 0 0 1-.293c.573-.347.906-.96.906-1.627v-7.373c.014-1.254-.693-2.4-1.84-2.974"
    ></path>
    <path
      fill={color}
      fillOpacity="0.8"
      d="M29.376 14.87v7.373a3.33 3.33 0 0 1-1.853 2.986l-7.8 3.907a1.91 1.91 0 0 1-1.867-.093 1.91 1.91 0 0 1-.907-1.627v-7.36a3.33 3.33 0 0 1 1.854-3l2.866-1.427 2-1 2.934-1.466c.6-.307 1.293-.28 1.866.08.56.346.907.96.907 1.627"
    ></path>
  </svg>
);

export default Custom_Box_Grey;
